import { Injectable } from '@angular/core';
import { TrafficAlertType, AAClusterType } from 'src/app/modules/google-map/enums/google-map-enum';
import { MarkerIcon, ILatLngBounds } from 'src/app/core/models/google-map-models';

@Injectable({
  providedIn: 'root'
})
export class AAGoogleIconService {

  constructor() { }

  getServiceStationIcon(isNano: boolean = false): any {
    const sizeX = 20, sizeY = 20;
    const icon: MarkerIcon = {
      url: './assets/icons/png@2x/icon-service-station@2x.png',
      size: new google.maps.Size(sizeX, sizeY),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(sizeX / 2, sizeY / 2),
      scaledSize: new google.maps.Size(sizeX, sizeY)
    };

    if (isNano) {
      icon.scaledSize = new google.maps.Size(13, 13);
    }
    return icon;
  }

  getRestaurantIcon(): any {
    const sizeX = 18, sizeY = 18;
    const icon: MarkerIcon = {
      url: './assets/icons/png@2x/icon-restaurant@2x.png',
      size: new google.maps.Size(sizeX, sizeY),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(sizeX / 2, sizeY / 2),
      scaledSize: new google.maps.Size(sizeX, sizeY)
    };
    return icon;
  }

  getHotelIcon(): any {
    const sizeX = 18, sizeY = 18;
    const icon: MarkerIcon = {
      url: './assets/icons/png@2x/icon-hotel@2x.png',
      size: new google.maps.Size(sizeX, sizeY),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(sizeX / 2, sizeY / 2),
      scaledSize: new google.maps.Size(sizeX, sizeY)
    };
    return icon;
  }

  getDirectionIcon(): any {
    const sizeX = 32, sizeY = 40;

    const icon: MarkerIcon = {
      url: './assets/icons/svg/icon-pin.svg',
      size: new google.maps.Size(sizeX, sizeY),
      origin: new google.maps.Point(0, 0),
      anchor: null, // new google.maps.Point(sizeX/2, sizeY/2),
      scaledSize: new google.maps.Size(sizeX, sizeY),
    };
    icon.labelOrigin = new google.maps.Point(sizeX / 2, (sizeY - 5) / 2);

    return icon;
  }

  getClusterIcon(clusterType: AAClusterType): MarkerIcon {
    const sizeX = 30, sizeY = 30;

    let url: string;
    switch (clusterType) {
      case AAClusterType.TRAFFIC_ALERT_CLUSTER:
        url = `./assets/icons/png@2x/icon-cluster-red.png`;
        break;
      case AAClusterType.CAR_PARK_CLUSTER:
        url = './assets/icons/png@2x/icon-cluster-blue.png';
        break;
      case AAClusterType.TRAVEL_CLUSTER:
        url = './assets/icons/png@2x/icon-cluster-yellow.png';
        break;
    }

    const icon: MarkerIcon = {
      url: url,
      size: new google.maps.Size(sizeX, sizeY),
      origin: new google.maps.Point(0, 0),
      anchor: null, // new google.maps.Point(sizeX/2, sizeY/2),
      scaledSize: new google.maps.Size(sizeX, sizeY)
    };

    return icon;
  }

  getTrafficAlertIcon(iconType: TrafficAlertType): MarkerIcon {

    let sizeX = 23, sizeY = 23;
    const icon: MarkerIcon = {
      url: '',
      size: new google.maps.Size(sizeX, sizeY),
      origin: new google.maps.Point(0, 0),
      anchor: null, // new google.maps.Point(sizeX/2, sizeY/2),
      scaledSize: new google.maps.Size(sizeX, sizeY),
    };

    switch (iconType) {
      case TrafficAlertType.INCIDENTS:
        icon.url = './assets/icons/png@2x/icon-incidents@2x.png';
        break;

      case TrafficAlertType.CONGESTION:
        icon.url = './assets/icons/png@2x/icon-congestion@2x.png';
        break;

      case TrafficAlertType.ROADWORKS:
        icon.url = './assets/icons/png@2x/icon-roadworks@2x.png';
        break;

      case TrafficAlertType.LANE_CLOSED:
        sizeX = 20; sizeY = 20;
        icon.url = './assets/icons/png@2x/icon-lane-closed@2x.png';
        break;

      case TrafficAlertType.ROAD_CLOSURES:
        sizeX = 18; sizeY = 18;
        icon.url = './assets/icons/png@2x/icon-road-closure@2x.png';
        break;

      case TrafficAlertType.WEATHER_INCIDENTS:
        icon.url = './assets/icons/png@2x/icon-weather-incidents@2x.png';
        break;
    }

    // update once again
    icon.size = new google.maps.Size(sizeX, sizeY);
    // icon.anchor = new google.maps.Point(sizeX/2, sizeY/2);
    icon.scaledSize = new google.maps.Size(sizeX, sizeY);

    return icon;
  }

  getCarParkIcon(): any {
    const sizeX = 18, sizeY = 18;
    const icon: MarkerIcon = {
      url: './assets/icons/png@2x/icon-car-park@2x.png',
      size: new google.maps.Size(sizeX, sizeY),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(sizeX / 2, sizeY / 2),
      scaledSize: new google.maps.Size(sizeX, sizeY)
    };
    return icon;
  }

  iconShadow() {
    const icon: MarkerIcon = {
      url: './assets/images/map-sprite-006.png',
      size: new google.maps.Size(31, 17),
      origin: new google.maps.Point(0, 203),
      anchor: new google.maps.Point(0, 17)
    };
    return icon;
  }

  drawRectangle(bounds: ILatLngBounds) {
    const ne = bounds.getNorthEast();
    const sw = bounds.getSouthWest();
    const _bounds = {
      north: ne.lat(),
      south: sw.lat(),
      east: ne.lng(),
      west: sw.lng()
    };

    return new google.maps.Rectangle({
      strokeColor: '#FF0000',
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: '#FF0000',
      fillOpacity: 0.35,
      bounds: _bounds
    });
  }
}

